/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Welcome_DescriptionInputs */

const es_walkthrough_welcome_description = /** @type {(inputs: Walkthrough_Welcome_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te damos un recorrido rápido por la plataforma para que puedas aprovecharla al máximo. Solo tomará un momento.`)
};

const en_walkthrough_welcome_description = /** @type {(inputs: Walkthrough_Welcome_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let us give you a quick tour of the platform so you can get the most out of it. It will only take a moment.`)
};

/**
* | output |
* | --- |
* | "Let us give you a quick tour of the platform so you can get the most out of it. It will only take a moment." |
*
* @param {Walkthrough_Welcome_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_welcome_description = /** @type {((inputs?: Walkthrough_Welcome_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Welcome_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_welcome_description(inputs)
	return en_walkthrough_welcome_description(inputs)
});
export { walkthrough_welcome_description as "walkthrough.welcome_description" }